import React, { useState, ChangeEvent, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Rate, Divider, Button, message as Message } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { FaRegStar } from 'react-icons/fa';
import moment from 'moment';
import _ from 'lodash';
import i18n from 'i18next';

import { GlobalModalHandler, GlobalModalClose } from '../../layout/GlobalModal';
import { Orders } from '../../../store/orders/types';
import { getUserState } from '../../../store/user/selector';
import { rateGuest } from '../../../store/orders/actions';
import { getAppGlobalState } from '../../../store/app-globals/selectors';
import i18next from 'i18next';
import { colors } from '../../../constants/colors';
import { fnCheckForRestrictedWords } from '../../../constants/resctrictedWords';

interface RateProps {
  orders: Orders;
  navigate: Function;
  isGuest: boolean;
}

export const RateGuest = ({ orders, navigate, isGuest }: RateProps) => {
  const { cookDetails, consumptiondate, userdetails } = orders;
  const { user } = useSelector(getUserState);
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);

  const [rate, setRate] = useState<number>(0);
  const [note, setNote] = useState('');
  const dispatch = useDispatch();
  const isRatingUser = useRef(false);

  const seconds = _.get(consumptiondate, 'seconds');
  const orderdatetime = moment.unix(seconds).calendar();

  const handleRateChange = (value: number) => {
    setRate(value);
  };

  const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setNote(e.currentTarget.value);
  };

  const ratee = isGuest ? cookDetails?.id : userdetails.id;
  const handleSubmit = () => {
    const ratings = {
      rate,
      message: note,
      meal: orders.mealid,
      order: orders.id,
      timeadded: moment().toDate(),
      ratedby: user.userid,
      user: ratee || '',
    };
    if (fnCheckForRestrictedWords(note)) {
      Message.error(i18n.t('RESCTRICTED_MESSAGE'));
      return;
    }
    dispatch(rateGuest(ratings));
    isRatingUser.current = true;
  };

  const onPressSkip = () => {
    GlobalModalClose();
    navigate();
  };

  const userRated = () => {
    if (isRatingUser.current && !isLoading && !hasError) {
      GlobalModalClose();
      navigate();
    }
    if (isRatingUser.current && !isLoading && hasError) {
      Message.error('Something went wrong');
    }
  };

  const userAvatar = isGuest ? cookDetails?.image : userdetails.image;
  const userName = isGuest ? cookDetails?.firstName : userdetails.firstName;
  useEffect(userRated, [isLoading]);
  return (
    <div>
      <div className="modal-content-wrapper">
        <div className="modal-content-description">
          <span>
            {isGuest ? i18n.t('RATE_YOUR_COOK') : i18n.t('RATE_YOUR_GUEST')}
          </span>
          <div className="rate-cook-details">
            <img
              src={userAvatar}
              alt=""
              style={{ height: 60, width: 60, borderRadius: 30 }}
            />
            <span style={{ color: colors.green }}>{userName}</span>
            <div className="extra-text">{orderdatetime}</div>
          </div>
          <div className="ratings-container">
            <Rate
              character={<FaRegStar size={23} />}
              onChange={handleRateChange}
            />
          </div>
        </div>
      </div>
      <Divider />
      <div className="modal-content-wrapper">
        <TextArea
          rows={2}
          placeholder={i18n.t('WRITE_A_NOTE')}
          className="rating-note"
          onChange={handleInputChange}
        />
        <div className="button-container">
          <Button
            block
            type="primary"
            shape="round"
            className="continue-button continue-button-primary"
            disabled={rate === 0}
            loading={isLoading}
            onClick={handleSubmit}
          >
            <span className="continue-button-text">
              {message || i18next.t('SUBMIT')}
            </span>
          </Button>
          <Button
            type="link"
            block
            className="skip-button"
            onClick={onPressSkip}
          >
            {i18n.t('SKIP')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const rateGuestModalHandler = (
  meal: Orders,
  navigate: (e?: React.MouseEvent) => void,
  isGuest: boolean
) => {
  GlobalModalHandler({
    content: <RateGuest orders={meal} navigate={navigate} isGuest={isGuest} />,
  });
};
